import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface ApprovedProductAttributeAndDisclaimerTextCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const ApprovedProductAttributeAndDisclaimerTextCard: React.FC<
  ApprovedProductAttributeAndDisclaimerTextCardProps
> = ({ guideline, index, onEditClick }) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'ApprovedProductAttributeAndDisclaimerText') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Approved Product Attribute"
      onEditClick={onEditClick}
    />
  );
};
